module.exports = __webpack_public_path__ + "static/media/spinner.0d0345f6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/spinner.gif
// module id = 26
// module chunks = 0